"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function settle(val) {
  if (!Array.isArray(val)) val = [val];
  return Promise.all(val.map(function (p) {
    return p.then(function (value) {
      return {
        isFulfilled: true,
        isRejected: false,
        value: value
      };
    }).catch(function (reason) {
      return {
        isFulfilled: false,
        isRejected: true,
        reason: reason
      };
    });
  }));
}

exports.settle = settle;
exports.default = settle;